import dayjs from 'dayjs';
import { IChat } from 'interfaces';

export const sortChatsByLastMessage = (chats: IChat[]): IChat[] => {
  return [...chats].sort((a, b) => {
    const dateA = a.last_message?.created_at || a.created_at;
    const dateB = b.last_message?.created_at || b.created_at;
    
    return dayjs(dateB).unix() - dayjs(dateA).unix();
  });
};

export default sortChatsByLastMessage; 